import React from 'react'

function String() {
    return (
        <span className='cs-data-string'>String</span>
    )
}

export { String }